import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {TokenService} from "../../auth";
import {UserActivationService, UserService} from '../../services';

@Component({
  selector: 'app-password-recover',
  templateUrl: './password-recover.component.html'
})
export class PasswordRecoverComponent implements OnInit {

  busy = false;
  error = false;

  @Input() email: string;
  displayRecoverPasswordDialog: boolean = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private userActivationService: UserActivationService
  ) {
  }

  ngOnInit() {

  }

  showRecoverPasswordDialog() {
    this.displayRecoverPasswordDialog = true;
  }

  cancelRecoverPassword() {
    this.displayRecoverPasswordDialog = false;
  }

  recoverPassword() {
    this.busy = true;
    this.userActivationService.recoverPassword(this.email).subscribe(
      () => {
        this.cancelRecoverPassword();
        this.busy = false;
      },
      () => {
        this.cancelRecoverPassword();
        this.busy = false;
      }
    );
  }




}
